import { render, staticRenderFns } from "./his.vue?vue&type=template&id=268b4a7e&scoped=true"
import script from "./his.vue?vue&type=script&lang=js"
export * from "./his.vue?vue&type=script&lang=js"
import style0 from "./his.vue?vue&type=style&index=0&id=268b4a7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b4a7e",
  null
  
)

export default component.exports